import React, { Children } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper'
import 'swiper/css'
import classNames from 'classnames'
export type TextDataType = { val: React.ReactNode; link?: string }[]

export const MyTextVertical: React.FC<{
  style?: React.CSSProperties
  className?: string
  contentClassName?: string
  data: TextDataType
}> = props => {
  const { style, className, contentClassName, data } = props

  return (
    <div style={style} className={classNames(className, 'w-ful h-full')}>
      {!!data.length && (
        <Swiper
          className="w-ful h-full"
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          speed={1000}
          direction="vertical"
          allowTouchMove={false}
          modules={[Autoplay]}
        >
          {data.map((item, index: number) => (
            <SwiperSlide key={index}>
              <div className={contentClassName}>
                {item?.link ? (
                  <a href={item?.link} target="_blank" rel="noreferrer">
                    {item.val}
                  </a>
                ) : (
                  <>{item?.val}</>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  )
}
